import { BaseCurrencyInput } from "@components/CurrencyInput/BaseCurrencyInput";
import { Hairline } from "../../../components/Hairline";
import { Label } from "../../../components/Label";
import { If } from "shared/components/control-statements";

import styles from "@styles/CashbackProgram.module.scss";

export const ValuesStep = ({ cashbackProgram, programLabels, onChange }) => {
  const getValueSufix = () => {
    const programType = cashbackProgram?.type || "CASHBACK";

    if (programType === "POINT") {
      return {
        singular: programLabels?.[programType].singular || "ponto",
        plural: programLabels?.[programType].plural || "pontos",
      };
    }

    return {
      singular: programLabels?.[programType].singular || "cashback",
      plural: programLabels?.[programType].plural || "cashback",
    };
  };

  const valueSufix = getValueSufix();

  return (
    <>
      <div>
        <If
          cond={!cashbackProgram?.type || cashbackProgram?.type === "CASHBACK"}
        >
          <Label
            text={`Determine o percentual do ${valueSufix.singular}`}
            className={"mb-20"}
          />
          <BaseCurrencyInput
            design="two"
            className="w-100"
            max={3}
            suffix="%"
            prefix=""
            precision={0}
            value={cashbackProgram.percentage || 0}
            onChange={(percentage) => {
              onChange &&
                onChange({
                  ...cashbackProgram,
                  percentage,
                });
            }}
          />
        </If>

        <If cond={cashbackProgram?.type === "POINT"}>
          <Label text={"Determine o câmbio"} className={"mb-20"} />
          <div className="d-flex align-center">
            <BaseCurrencyInput
              design="two"
              className="w-100"
              suffix={" gastos"}
              value={100}
              disabled
            />
            <span className={styles.equal}>=</span>
            <BaseCurrencyInput
              design="two"
              suffix={` ${
                cashbackProgram.percentage === 1
                  ? valueSufix.singular
                  : valueSufix.plural
              }`}
              prefix={""}
              precision={0}
              className="w-100"
              value={cashbackProgram.percentage || 0}
              onChange={(percentage) => {
                onChange &&
                  onChange({
                    ...cashbackProgram,
                    percentage,
                  });
              }}
            />
          </div>
        </If>
      </div>
      <Hairline className="mt-10 mb-20" />
      <div>
        <Label text={"Defina a expiração"} className={"mb-20"} />
        <BaseCurrencyInput
          design="two"
          className="w-100 mb-20"
          type="number"
          prefix={""}
          suffix=" dias"
          precision={0}
          value={cashbackProgram.expiration_days || 0}
          onChange={(expiration_days) => {
            onChange &&
              onChange({
                ...cashbackProgram,
                expiration_days,
              });
          }}
        />
      </div>
      <Hairline className="mt-10 mb-20" />
      <div>
        <Label
          text={`Determine o valor máximo de ${valueSufix.plural}`}
          className={"mb-20"}
        />
        <If cond={cashbackProgram?.type === "POINT"}>
          <BaseCurrencyInput
            design="two"
            suffix={` ${
              cashbackProgram.max_gain === 1
                ? valueSufix.singular
                : valueSufix.plural
            }`}
            prefix={""}
            precision={0}
            className="w-100"
            value={cashbackProgram.max_gain || 0}
            onChange={(max_gain) => {
              onChange &&
                onChange({
                  ...cashbackProgram,
                  max_gain,
                });
            }}
          />
        </If>
        <If cond={cashbackProgram?.type === "CASHBACK"}>
          <BaseCurrencyInput
            design="two"
            className="w-100 mb-20"
            value={cashbackProgram.max_gain || 0}
            onChange={(max_gain) => {
              onChange &&
                onChange({
                  ...cashbackProgram,
                  max_gain,
                });
            }}
          />
        </If>
      </div>
    </>
  );
};
